// extracted by mini-css-extract-plugin
export default {"alignment":"Alignment_alignment__kFZVs","sides":"Alignment_sides__bNMDD","selected":"Alignment_selected__YBPB3"};